import style from '../listaReceitaExportacoes.module.scss';
import { useState } from 'react';
import ComponenteNCM from '../../../../../../componenteNCM/componenteNCM';
import { ETipoOperacao } from '../../../../../../../../../../../../enums/ETipoOperacao';
import {
  IReceitaExportacoesNCM,
  IReceitaExportacoesVinculadaNCM,
} from '../../../../../../../../../../../../interfaces/IReceitaExportacoes';

interface IListaReceitaExportacoesItemProps {
  receitaExportacoes: IReceitaExportacoesNCM[] | IReceitaExportacoesVinculadaNCM[];
  isVinculada: boolean;
}

const ListaReceitaExportacoesItem = ({ receitaExportacoes, isVinculada }: IListaReceitaExportacoesItemProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  return (
    <>
      <div
        className={style.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={style.title}>
            {isVinculada
              ? 'Com operação de exportação com Pessoa Vinculada/Interposta/País com Tributação Favorecida'
              : 'Sem operação de exportação com Pessoa Vinculada/Interposta/País com Tributação Favorecida'}
          </div>
        </div>
        <div className={style.rightContainer}></div>
      </div>
      {isAccordionOpen && (
        <div className={style.accordionContent}>
          <ComponenteNCM
            isEdicaoNcm={false}
            isReadOnly={true}
            ncmListaData={receitaExportacoes}
            type={ETipoOperacao.RECEITA_CALCULADA_EXPORTACOES}
          />
        </div>
      )}
    </>
  );
};

export default ListaReceitaExportacoesItem;
